<template>
    <v-container>
        <!-- title / add  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <v-toolbar flat>
            <v-toolbar-title class="text-uppercase body-1 font-weight-medium">Solar Costs</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>

            <div class="flex-grow-1"></div>

            <!-- add ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" fab small text>
                        <v-icon large color="orange darken-2">mdi-plus-circle-outline</v-icon>
                    </v-btn>
                </template>
                <!-- add dialog ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="editedItem.arrayCapacity"
                            label="Array Capacity"
                            suffix="kW"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-select
                            :items="trackingTypes"
                            v-model="editedItem.tracking"
                            label="Tracking"
                            required
                            item-text="name"
                            item-value="id"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="editedItem.orientation"
                            label="Orientation"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="editedItem.tilt"
                            label="Tilt"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="editedItem.latitude"
                            label="Latitude"
                            class="mr-3"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            v-model="editedItem.longitude"
                            label="Longitude"
                            class="mr-3"
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="close" small color="primary" text>Cancel</v-btn>
                    <v-btn @click.native="save" small color="primary" >Save</v-btn>
                  </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>

    <!-- table ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <v-data-table
            :headers="headers"
            :items="components"
            :search="search"
            :sort-by="['arrayCapacity']"
            :sort-desc="[false]"
            hide-default-footer
            multi-sort
            class="mb-5">

            <!-- no-data ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template slot="no-data" class="text-left">
                <v-alert :value="true" color="info" dark>
                    <span class="title text-left">
                        <v-icon color="orange">warning</v-icon>
                        No components found.
                    </span>
                    <v-btn @click="initialize" color="white">Reset</v-btn>
                </v-alert>
            </template>

            <!-- content ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template v-slot:item.tracking="{ item }">
                {{ getTrackingTypeName(item.tracking) }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon @click="editItem(item)" class="mr-2" color="primary">
                    edit
                </v-icon>
                <v-icon @click="deleteItem(item)" color="red darken-2">
                  delete_forever
                </v-icon>
            </template>

        </v-data-table>
    </v-container>
</template>

<script>
export default {
  data: () => ({
    search: '',
    dialog: false,
    headers: [
      { text: 'Array Capacity', sortable: true, value: 'arrayCapacity' },
      { text: 'Orientation', sortable: true, value: 'orientation' },
      { text: 'Tilt', sortable: true, value: 'tilt' },
      { text: 'Tracking', sortable: true, value: 'tracking' },
      { text: 'Latitude', sortable: true, value: 'latitude' },
      { text: 'Longitude', sortable: true, value: 'longitude' },
      { text: 'Actions', sortable: false, value: 'actions' }
    ],
    components: [],
    editedItem: {
      arrayCapacity: '',
      orientation: '',
      tilt: '',
      tracking: '',
      latitude: '',
      longitude: ''
    },
    defaultItem: {
      arrayCapacity: '',
      orientation: '',
      tilt: '',
      tracking: '',
      latitude: '',
      longitude: ''
    },
    trackingTypes: [
      {
        id: 1,
        name: 'None'
      },
      {
        id: 2,
        name: 'Dual Axis'
      }
    ],
    latitudeTypes: [
      {
        id: 1,
        name: 'North'
      },
      {
        id: 2,
        name: 'South'
      }
    ],
    longitudeTypes: [
      {
        id: 1,
        name: 'East'
      },
      {
        id: 2,
        name: 'West'
      }
    ]
  }),
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.components = [
        {
          arrayCapacity: '1488',
          orientation: '188.5',
          tilt: '31.30',
          tracking: 2,
          latitude: '41.2',
          longitude: '77.1'
        },
        {
          arrayCapacity: '714',
          orientation: '181.0',
          tilt: '32.10',
          tracking: 1,
          latitude: '40.9',
          longitude: '77.2'
        }
      ]
    },
    getTrackingTypeName(id) {
      return this.trackingTypes.find(function(f) {
        return f.id === id
      }).name
    },

    editItem(item) {
      this.editedIndex = this.components.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.components.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.components.splice(index, 1)
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      this.$toast.success("Component saved successfully")
      if (this.editedIndex > -1) {
        Object.assign(this.components[this.editedIndex], this.editedItem)
      } else {
        this.components.push(this.editedItem)
      }
      this.close()
    }
  }
}
</script>
